export default __webpack_public_path__ + "static/audio-cardio-6-b-2658469ca33880017416774370f97159.webp";